import { Injectable } from '@angular/core';
import {
  CreateCertificationChangeRequestInput,
  CreateCertificationChangeRequestMutation,
  CreateCertificationFromTemplateInput,
  CreateCertificationFromTemplateMutation,
  LoadCertificationDetailsQuery,
  LoadLearnerCertificationListQuery,
  LoadTrainingManagerCertificationListQuery,
  LoadTrainingManagerCertificationListQueryVariables,
  PostCertificationToCrediveraInput,
  PostCertificationToCrediveraMutation,
  UploadCertificationInput,
  UploadCertificationMutation
} from '@queries/generated';
import { finalMap } from '@rx/final-map';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CertificationsService {
  mine$ = this.loadLearnerCertificationsQuery
    .watch({ includeArchived: true })
    .valueChanges.pipe(map(({ data }) => data.viewer.certifications));

  constructor(
    private loadLearnerCertificationsQuery: LoadLearnerCertificationListQuery,
    private loadTrainingManagerCertificationsQuery: LoadTrainingManagerCertificationListQuery,
    private loadCertificationDetailsQuery: LoadCertificationDetailsQuery,
    private createCertificationChangeRequestMutation: CreateCertificationChangeRequestMutation,
    private createCertificationFromTemplateMutation: CreateCertificationFromTemplateMutation,
    private uploadCertificationMutation: UploadCertificationMutation,
    private postCertificationToCrediveraMutation: PostCertificationToCrediveraMutation
  ) {}

  trainingManagerCertifications = (vars: LoadTrainingManagerCertificationListQueryVariables) => {
    // Only load 250 certs, have to search for the rest of them
    const variables = { ...vars, first: 250 };
    return this.loadTrainingManagerCertificationsQuery
      .watch(variables)
      .valueChanges.pipe(map(({ data }) => data.certifications.all.nodes));
  };

  find = (id: number) => {
    return this.loadCertificationDetailsQuery.fetch({ id }).pipe(map(({ data }) => data.certifications.findById));
  };

  createChangeRequest(input: CreateCertificationChangeRequestInput) {
    return this.createCertificationChangeRequestMutation.mutate({ input }).pipe(
      map(({ data }) => data.createCertificationChangeRequest),
      finalMap('changeRequest')
    );
  }

  upload(input: UploadCertificationInput) {
    return this.uploadCertificationMutation
      .mutate(
        { input },
        {
          refetchQueries: ['LoadLearnerCertificationList']
        }
      )
      .pipe(
        map(({ data }) => data.uploadCertification),
        finalMap('certification')
      );
  }

  postToCredivera(input: PostCertificationToCrediveraInput) {
    return this.postCertificationToCrediveraMutation
      .mutate({ input })
      .pipe(map(({ data }) => data.postCertificationToCredivera));
  }

  createCertificationFromTemplate(input: CreateCertificationFromTemplateInput) {
    return this.createCertificationFromTemplateMutation.mutate({ input }).pipe(
      map(({ data }) => data.createCertificationFromTemplate),
      finalMap('certification')
    );
  }
}
